// MUI components
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';

export const Content = styled(Box)({
  gap: 10,
  display: 'flex',
  flexDirection: 'column',
});

export const FieldWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'gap',
})(({ gap }) => ({
  gap: gap ?? 4,
  display: 'flex',
  flexDirection: 'column',
}));

export const IconWrapper = styled(Box, {
  shouldForwardProp: (prop) => !['bg'].includes(prop),
})(({ bg }) => ({
  height: 28,
  width: 30,
  borderRadius: 8,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  background: bg,
}));

export const NoteText = styled(Typography)({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '19.92px',
  letterSpacing: '0.4px',
  color: 'rgba(97, 97, 97, 1)',
});

export const AccessSelection = styled(Box)({
  padding: '10px 10px',
  '& .permissionItem': {
    padding: '10px',
    cursor: 'pointer',
    borderRadius: 10,
    '& .title': {
      fontWeight: 700,
      fontSize: 14,
      lineHeight: '16px',
      letterSpacing: 0,
      color: 'rgba(66, 66, 66, 1)',
      marginBottom: 5,
    },
    '& .description': {
      fontWeight: 500,
      fontSize: 13,
      lineHeight: '16px',
      letterSpacing: 0,
      color: 'rgba(66, 66, 66, 1)',
    },
  },
});

export const SelectedAccess = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  width: '100%',
  cursor: 'pointer',
  border: '1px solid #E0E0E0',
  borderRadius: 10,
  padding: '7px 10px',
  marginTop: 10,

  '& .dropdownIcon': {
    fontSize: 24,
    color: '#00000099',
  },
  '& .selectedLabel': {
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '16px',
    letterSpacing: 0,
    color: 'rgba(0, 0, 0, 1)',
  },
});

export const ToolTipContent = styled(Box)({
  padding: '18px 20px',
  backgroundColor: 'white',
  width: 450,
  '& .title': {
    fontWeight: 800,
    fontSize: 16,
    lineHeight: '20px',
    letterSpacing: 0,
    color: 'rgba(0, 0, 0, 1)',
    marginBottom: 8,
  },
  '& .headerAndDescription': {
    marginBottom: 15,
  },
  '& .subHeader': {
    fontWeight: 800,
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: 0,
    color: 'rgba(0, 0, 0, 1)',
  },
  '& .description': {
    fontWeight: 500,
    fontSize: 13,
    lineHeight: '20px',
    letterSpacing: 0,
    color: 'rgba(0, 0, 0, 1)',
  },

  '& .bold': {
    fontWeight: 800,
    fontSize: 13,
    lineHeight: '18px',
    letterSpacing: 0,
    color: 'rgba(0, 0, 0, 1)',
  },
  '& .infoBox': {
    padding: '12px 14px',
    borderRadius: 8,
    backgroundColor: 'rgba(255, 248, 225, 1)',

    '& .lightbulbIcon': {
      fill: 'rgba(255, 160, 0, 1)',
      stroke: 'rgba(255, 160, 0, 1)',
      marginBottom: 5,
      '& path': {
        fill: 'rgba(255, 160, 0, 1)',
        stroke: 'rgba(255, 160, 0, 1)',
      },
    },
    '& .description': {
      fontWeight: 500,
      fontSize: 13,
      lineHeight: '20px',
      letterSpacing: 0,
      color: 'rgba(0, 0, 0, 1)',
    },
  },
});

export const BoldSpan = styled('span')({
  fontWeight: 800,
  fontSize: '13px',
  lineHeight: '20px',
  letterSpacing: 0,
  color: 'rgba(0, 0, 0, 1)',
});

export const Dot = styled('span')({
  margin: '0px 6px',
  color: 'black',
});
